import React from 'react';

const AWS_Regions = () => {
  return (
    <div>
      <h1>AWS_Regions</h1>
      <p>This is the AWS_Regions component.</p>
    </div>
  );
};

export default AWS_Regions;
